import PropTypes from 'prop-types'
import { externalDataSharingOptionsPropType } from './external-data-sharing-options-prop-type'

/**
 * @typedef {Object} externalDataSharingPropType
 * @property {string}                                       [contractId]                    - The identifier for the associated contract
 * @property {string}                                       [dataSharingId]                 - The identifier for the data sharing entry (WfExtDataSharing)
 * @property {string}                                       [dataSharingProviderId]         - The identifier for the the 3rd party partner for external data sharing
 * @property {array<externalDataSharingOptionsPropType>}    [externalDataSharingOptions]    - The list of selected data sharing options for the booking
 * @property {string}                                       [featureMetaDataId]             - The identifier of the related feature data record (WfFeatureMetaData)
 * @property {string}                                       [genericExternalRef1]           - A free-text field for external references like customer number
 * @property {string}                                       [genericExternalRef2]           - A free-text field for external references like license plate
 * @property {string}                                       [recurringCustomerBookingId]    - The identifier of the related recurring customer booking (WfBillRecurringCustomerBooking)
 */
export const externalDataSharingPropType = PropTypes.shape({
    contractId: PropTypes.string,
    dataSharingId: PropTypes.string,
    dataSharingProviderId: PropTypes.string,
    externalDataSharingOptions: PropTypes.arrayOf(externalDataSharingOptionsPropType),
    featureMetaDataId: PropTypes.string,
    genericExternalRef1: PropTypes.string,
    genericExternalRef2: PropTypes.string,
    recurringCustomerBookingId: PropTypes.string
})
